export default {
  INBOX: 'INBOX',
  SENT: 'SENT',
};



// WEBPACK FOOTER //
// ./src/modules/message/components/messages-tab/tabs.js